import './style.scss';

// ServicesGrid Component JavaScript

document.addEventListener('DOMContentLoaded', function() {
    const components = document.querySelectorAll('.booom-services-grid');

    components.forEach(function(component) {
        // Add your JavaScript functionality here
    });
});
